export const Map_Z_Index = 1;

export const Legend_Z_Index = 5;
